import { onDelegatedEvent, setLoading, initAllModules, viewTransition, replacePageContent } from '../functions.js';

export default class AjaxNavigationElement extends HTMLElement {

    _args = {};
    _abortController = null;
    _replaceTarget = null;
    
    constructor() {
        super();

        if (getComputedStyle(this).display === 'inline') {
            this.style.display = 'block';
        }
    }

    connectedCallback() {

        this._args = this.dataset;
        
        if (!this._args.selector) { throw new Error('AjaxLoadOnClickModule: selector is required'); }
    
        if (!this.#getReplaceTarget().getAttribute('id')) {
            throw new Error('AjaxNavigation: target must have an id in order to be replaced');
        }

        onDelegatedEvent('click', this, this._args.selector, this._onClick.bind(this));
        
        this._reinitAbortController();
        
        this._bindedOnPopState = this._onPopState.bind(this);
        window.addEventListener('popstate', this._bindedOnPopState);
        
    }

    disconnectedCallback() {
        window.removeEventListener('popstate',  this._bindedOnPopState);
    }

    _bindedOnPopState = null;
    _onPopState(event) {
        this._navigate(document.location.href);
    }

    #getReplaceTarget() {
        return this.querySelector(this._args.target) || this;
    }

    _onClick(event) {
        event.preventDefault();

        let realTarget = event.target.closest(this._args.selector);
        if (!realTarget) { return; }
        
        history.pushState({}, '', realTarget.href);
        this._navigate(realTarget.href);
    }

    _reinitAbortController() {
        if (this._abortController) {
            this._abortController.abort();
        }
        this._abortController = new AbortController();
    }

    _setThisLoading(loading) {
        let target = this._args.loadingSelector ? document.querySelector(this._args.loadingSelector) : this.#getReplaceTarget();
        setLoading(target, loading);
    }

    _navigate(url) {
        this._setThisLoading(true);
        this._reinitAbortController();

        let request = new Request(url, {
            headers: { 'X-Is-Ajax': '1' },
            signal: this._abortController.signal,
        });

        fetch(request)
            .then(res => res.text())
            .then(res => {
                this._setThisLoading(false);

                let replaceTarget = this.#getReplaceTarget();

                replacePageContent(replaceTarget, res, () => {

                    if (this._args.scroll) {
                        replaceTarget.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                        });
                    }

                    // this._dispatchEvents();
                });

            }).catch(err => {
                this._setThisLoading(false);
                console.error(err);
            });
    }

    navigateTo(url) {
        this._navigate(url);
    }
    
}

window.customElements.define('ajax-navigation', AjaxNavigationElement);
